import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { CalculatorsModule } from './calculators/calculators.module';
import { MainLayoutComponent } from './misc/components/main-layout/main-layout.component';
import { DataProviderAuthenticatedGuard } from './misc/guards/data-provider-authenticated.guard';
import { NetSheetPageModule } from './misc/pages/net-sheet/net-sheet.module';
import { WalkingFarmModule } from './misc/pages/walking-farm/walking-farm.module';
import { MapResolver } from './misc/resolvers/map.resolver';
import { MoreModule } from './more/more.module';
import { OnboardingModule } from './onboarding/onboarding.module';
import { PaymentModule } from './payment/payment.module';
import { PropertySearchModule } from './property-search/property-search.module';

const routes: Routes = [
  {
    loadChildren: () => OnboardingModule,
    path: 'onboarding'
  },
  {
    loadChildren: () => PaymentModule,
    path: 'payment'
  },
  {
    canActivate: [DataProviderAuthenticatedGuard],
    children: [
      {
        loadChildren: () => PropertySearchModule,
        path: 'property-search',
        resolve: {
          map: MapResolver
        }
      },
      {
        loadChildren: () => WalkingFarmModule,
        path: 'walking-farm',
        resolve: {
          map: MapResolver
        }
      },
      {
        loadChildren: () => NetSheetPageModule,
        path: 'net-sheet'
      },
      {
        loadChildren: () => CalculatorsModule,
        path: 'calculators'
      },
      {
        loadChildren: () => MoreModule,
        path: 'more'
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'property-search'
      }
    ],
    component: MainLayoutComponent,
    path: ''
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'onboarding'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      preloadingStrategy: PreloadAllModules,
      useHash: true
    })
  ]
})
export class CoreRoutingModule {}
